import store from '../store';

export const isExpired = () => {
  // ログインしていなかったらチェックをしない
  if (!store.state.user.accessToken) return false

  const currentDate = new Date().toLocaleString({ timeZone: 'Asia/Tokyo' })
  const diff = (new Date(currentDate) - new Date(store.state.user.lastOperatedDate)) / 1000
  return diff >= 1 * 60 * 60
}


export const logOut = async() => {
  store.commit('user/logout')
  store.commit('user/setRole', { role: null })
  store.commit('user/setLastOperatedDate', { lastOperatedDate: null })
}

// ログアウト後に戻るログインページ。お試しアカウント(uidが「o-」始まり)は/otameshi
// ※ storeがクリアされる前(logOutを呼ぶ前)に取得すること
export const loginPath = () => {
  return store.state.user.uid?.startsWith('o-') ? '/otameshi' : '/sign_in'
}
